import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules, ROUTES  } from '@angular/router'; 
import { AuthGuard } from 'src/lib/core/authentication/auth.guard';
import { LocalStorage, LocalStorageService } from 'ngx-store';

//Component
import { PagesComponent } from './pages/pages.component';
import { BlankComponent } from './pages/blank/blank.component';
import { SearchComponent } from './pages/search/search.component';
import { AdvancedComponent } from './pages/advanced/advanced.component';
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';
import { AddUpdateTaskComponent } from './pages/addupdatetask/addupdatetask.component';
import { TasksComponent } from './pages/tasks/tasks.component';
import { PeopleContactsComponent } from './pages/peoplecontacts/peoplecontacts.component';
import { ComplianceComponent } from './pages/compliance/compliance.component';
import { SummaryComponent } from './pages/compliance/summary/summary.component';
import { MessagingComponent } from './pages/messaging/messaging.component';
import { IncidentsComponent } from './pages/incidents/incidents.component';
import { QualityAssuranceReportComponent } from './pages/qar/qar.component';
import { JobNotificationsComponent } from './pages/jobnotifications/jobnotifications.component';
import { ComponentsSettingsService } from './services/components_settings.service';

// export const routes: Routes = [
//   {
//     path: '', 
//     component: PagesComponent,
//     children:[
//       { path: '', loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule), data: { breadcrumb: 'Dashboard' }  },   
//       { path: 'profile', loadChildren: () => import('./pages/profile/profile.module').then(m => m.ProfileModule), data: { breadcrumb: 'Profile' }  }, 
//       { path: 'settings', loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsModule), data: { breadcrumb: 'Settings' }  },
//       { path: 'fleet', loadChildren: () => import('./pages/fleet/fleet.module').then(m => m.FleetModule)  },    
//       { path: 'bookings', loadChildren: () => import('./pages/bookings/bookings.module').then(m => m.BookingsModule)  },    
//       { path: 'drivers', loadChildren: () => import('./pages/drivers/drivers.module').then(m => m.DriversModule)  },    
//       { path: 'qar', component: QualityAssuranceReportComponent, data: { breadcrumb: 'Quality Assurance Report' } }, 
//       { path: 'payrolls', loadChildren: () => import('./pages/payrolls/payrolls.module').then(m => m.PayrollsModule), data: { breadcrumb: 'Payrolls' }  },  
//       { path: 'dispatch', loadChildren: () => import('./pages/dispatch/dispatch.module').then(m => m.DispatchModule) },
//       { path: 'employee-registrations', component: EmployeeRegistrationsComponent, data: { breadcrumb: 'Employee Registrations' } },
//       { path: 'employee-registrations/applicant', component: EmployeedetailsComponent, data: { breadcrumb: 'Employee Details' } },
//       { path: 'blank', component: BlankComponent, data: { breadcrumb: 'Blank page' } },
//       { path: 'search', component: SearchComponent, data: { breadcrumb: 'Search' } },
//       { path: 'advanced', component: AdvancedComponent, data: { breadcrumb: 'Advanced Search' } },
//       { path: 'tasks', component: TasksComponent, data: { breadcrumb: 'Tasks' } },
//       { path: 'addupdatetask', component: AddUpdateTaskComponent, data: { breadcrumb: 'Add & Update Task' } },
//       { path: 'users', loadChildren: () => import('./pages/users/users.module').then(m => m.UsersModule), data: { breadcrumb: 'Admin Account' }  },
//       { path: 'customers', loadChildren: () => import('./pages/customers/customer.module').then(m => m.CustomersModule), data: { breadcrumb: 'Customers' }  },
//       { path: 'suppliers', loadChildren: () => import('./pages/suppliers/suppliers.module').then(m => m.SuppliersModule), data: { breadcrumb: 'Suppliers' }  },
//       { path: 'peoplecontacts', component: PeopleContactsComponent, data: { breadcrumb: 'People Contacts' } },
//       { path: 'documents', loadChildren: () => import('./pages/documents/documents.module').then(m => m.DocumentsModule), data: { breadcrumb: 'Documents' }  },  
//       { path: 'maptracker', loadChildren: () => import('./pages/maptracker/maptracker.module').then(m => m.MapTrackerModule), data: { breadcrumb: 'Map Tracker' }  },
//       { path: 'compliance', redirectTo: 'compliance/summary' , pathMatch: 'full' },
//       { path: 'compliance/summary', component:SummaryComponent , data: { breadcrumb: 'Compliance' } },
//       { path: 'compliance/list', component:ComplianceComponent , data: { breadcrumb: 'Compliance List' } },
//       { path: 'messaging', component: MessagingComponent, data: { breadcrumb: 'Messaging' } },
//       { path: 'incidents', component: IncidentsComponent, data: { breadcrumb: 'Incidents' } },
//       { path: 'invoices', loadChildren: () => import('./pages/invoices/invoices.module').then(m => m.InvoicesModule), data: { breadcrumb: 'Invoices' }, canLoad: [AuthGuard], canActivate: [AuthGuard]  },
//       { path: 'bills', loadChildren: () => import('./pages/bills/bills.module').then(m => m.BillsModule), data: { breadcrumb: 'Bills' }, canLoad: [AuthGuard], canActivate: [AuthGuard]  },
//       { path: 'creditnotes', loadChildren: () => import('./pages/creditnotes/creditnotes.module').then(m => m.CreditNotesModule), data: { breadcrumb: 'Credit Notes' }  },  
//       { path: 'breaches', loadChildren: () => import('./pages/breach/breach.module').then(m => m.BreachModule), data: { breadcrumb: 'Breaches' }, canLoad: [AuthGuard] },
//       { path: 'fuel', loadChildren: () => import('./pages/fuel/fuel.module').then(m => m.FuelModule)  },   
//       { path: 'jobnotifications', component: JobNotificationsComponent, data: { breadcrumb: 'Activity Logs' } },
//     ]
//   },
//   { path: 'login', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule), canActivate:[AuthGuard] },
//   { path: 'logout', loadChildren: () => import('./pages/logout/logout.module').then(m => m.LogoutModule) },
//   { path: '**', component: NotFoundComponent }
// ]; 

@NgModule({
  imports: [
    RouterModule.forRoot([], {
      preloadingStrategy: PreloadAllModules, // <- comment this line for activate lazy load
      relativeLinkResolution: 'legacy',
      // useHash: true
    })
  ],
  exports: [
    RouterModule
  ],
  providers: [
    {
      provide: ROUTES,
      useFactory: (svc_component_settings : ComponentsSettingsService, svc_local_storage: LocalStorageService): Routes => {
        let routes: Routes = [];
        let children_routes = [];
        
        let tms_components = svc_local_storage.get('components');
        
        if(tms_components){
          var bookings = 0;
          var drivers = 0;
          var dispatch = 0;
          var invoice = 0;
          
          //dashboard
          children_routes.push({ path: '', loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule), data: { breadcrumb: 'Dashboard' }});
          
          tms_components.forEach(item=>{
           
            switch(item){
              
              //case 'Dashboard': {children_routes.push({ path: '', loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule), data: { breadcrumb: 'Dashboard' }});break;};
              
              case 'My Profile': {children_routes.push({ path: 'profile', loadChildren: () => import('./pages/profile/profile.module').then(m => m.ProfileModule), data: { breadcrumb: 'Profile' }  });break;};
              
              case 'Settings': {children_routes.push({ path: 'settings', loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsModule), data: { breadcrumb: 'Settings' }  });break;};
              
              case 'Fleet': {children_routes.push({ path: 'fleet', loadChildren: () => import('./pages/fleet/fleet.module').then(m => m.FleetModule)  });break;};   
              
              case 'Quality Assurance Report': {children_routes.push({ path: 'qar', component: QualityAssuranceReportComponent, data: { breadcrumb: 'Quality Assurance Report' } });break;}; 
              
              case 'Payrolls': {children_routes.push({ path: 'payrolls', loadChildren: () => import('./pages/payrolls/payrolls.module').then(m => m.PayrollsModule), data: { breadcrumb: 'Payrolls' }  });break;};  
              
              case 'Registrations': {
                    children_routes.push({ path: 'registrations', loadChildren: () => import('./pages/registrations/registrations.module').then(m => m.RegistrationsModule)});break;};
              
              case 'Advanced Search': {children_routes.push({ path: 'advanced', component: AdvancedComponent, data: { breadcrumb: 'Advanced Search' } });break;};
              
              case 'Tasks': {children_routes.push({ path: 'tasks', component: TasksComponent, data: { breadcrumb: 'Tasks' } });
                    children_routes.push({ path: 'addupdatetask', component: AddUpdateTaskComponent, data: { breadcrumb: 'Add & Update Task' } });break;};
              
              case 'Admin Accounts': {children_routes.push({ path: 'users', loadChildren: () => import('./pages/users/users.module').then(m => m.UsersModule), data: { breadcrumb: 'Admin Account' }  });break;};
              
              case 'Customers': {children_routes.push({ path: 'customers', loadChildren: () => import('./pages/customers/customer.module').then(m => m.CustomersModule), data: { breadcrumb: 'Customers' }  });break;};
              
              case 'Suppliers': {children_routes.push({ path: 'suppliers', loadChildren: () => import('./pages/suppliers/suppliers.module').then(m => m.SuppliersModule), data: { breadcrumb: 'Suppliers' }  });break;};
              
              case 'People Contacts': {children_routes.push({ path: 'peoplecontacts', component: PeopleContactsComponent, data: { breadcrumb: 'People Contacts' } });break;};
              
              case 'Documents': {children_routes.push({ path: 'documents', loadChildren: () => import('./pages/documents/documents.module').then(m => m.DocumentsModule), data: { breadcrumb: 'Documents' }  });break;};
              
              case 'Tracker': {children_routes.push({ path: 'maptracker', loadChildren: () => import('./pages/maptracker/maptracker.module').then(m => m.MapTrackerModule), data: { breadcrumb: 'Map Tracker' }  });break;};
              
              case 'Compliance': {children_routes.push({ path: 'compliance', redirectTo: 'compliance/summary' , pathMatch: 'full' });
                    children_routes.push({ path: 'compliance/summary', component:SummaryComponent , data: { breadcrumb: 'Compliance' } });break;};
              
              case 'Lists': {children_routes.push({ path: 'compliance/list', component:ComplianceComponent , data: { breadcrumb: 'Compliance List' } });break;};
              
              case 'Messaging': {children_routes.push({ path: 'messaging', component: MessagingComponent, data: { breadcrumb: 'Messaging' } });break;};
              
              case 'Incidents': {children_routes.push({ path: 'incidents', component: IncidentsComponent, data: { breadcrumb: 'Incidents' } });break;};
              
              case 'Bills': {children_routes.push({ path: 'bills', loadChildren: () => import('./pages/bills/bills.module').then(m => m.BillsModule), data: { breadcrumb: 'Bills' }, canLoad: [AuthGuard], canActivate: [AuthGuard]  });break;};
              
              case 'Credit Notes': {children_routes.push({ path: 'creditnotes', loadChildren: () => import('./pages/creditnotes/creditnotes.module').then(m => m.CreditNotesModule), data: { breadcrumb: 'Credit Notes' }  });break;};  
              
              case 'Breaches': {children_routes.push({ path: 'breaches', loadChildren: () => import('./pages/breach/breach.module').then(m => m.BreachModule), data: { breadcrumb: 'Breaches' }, canLoad: [AuthGuard] });break;};
              
              case 'Fuel': {children_routes.push({ path: 'fuel', loadChildren: () => import('./pages/fuel/fuel.module').then(m => m.FuelModule)  });break;};  
              
              case 'Activities': {children_routes.push({ path: 'jobnotifications', component: JobNotificationsComponent, data: { breadcrumb: 'Activity Logs' } });break;};

            };

            if((bookings ==0) && item =='Jobs' || item =='Create Booking' || item =='Import CSV' || item =='Connotes' ){
              bookings +=1;
              children_routes.push({ path: 'bookings', loadChildren: () => import('./pages/bookings/bookings.module').then(m => m.BookingsModule)});
            };

            if((drivers ==0) && item =='Drivers' || item =='Add Driver'){
              drivers +=1;
              children_routes.push({ path: 'drivers', loadChildren: () => import('./pages/drivers/drivers.module').then(m => m.DriversModule)  });
            };

            if((dispatch ==0) && item =='Local Dispatch' || item =='Linehaul Dispatch' || item =='Local Manifest' || item =='Linehaul Manifest' ){
              dispatch +=1;
              children_routes.push({ path: 'dispatch', loadChildren: () => import('./pages/dispatch/dispatch.module').then(m => m.DispatchModule) });
            };

            if((invoice ==0) && item =='Invoices' || item =='Add Select'){
              invoice +=1;
              children_routes.push({ path: 'invoices', loadChildren: () => import('./pages/invoices/invoices.module').then(m => m.InvoicesModule), data: { breadcrumb: 'Invoices' }, canLoad: [AuthGuard], canActivate: [AuthGuard]  });
            };

            children_routes.push({ path: 'search', component: SearchComponent, data: { breadcrumb: 'Search' } });              
            children_routes.push({ path: 'blank', component: BlankComponent, data: { breadcrumb: 'Blank page' }});
            
          });
        };

        if(svc_component_settings.access_role_name == 'Super Administrator'){
          children_routes.push({ path: 'superadmin', loadChildren: () => import('./pages/superadmin/superadmin.module').then(m => m.SuperAdminModule)});
        };
        
        routes.push(
          {
            path: '', 
            component: PagesComponent,
            children:children_routes
          },
          { path: 'login', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule), canActivate:[AuthGuard] },
          { path: 'logout', loadChildren: () => import('./pages/logout/logout.module').then(m => m.LogoutModule) },
          { path: '**', component: NotFoundComponent }
        );
      
        return [...routes];
      },
      deps: [ComponentsSettingsService, LocalStorageService],
      multi: true
    }
  ]
})
export class AppRoutingModule { }